// ─────────────────────────────────────────────
// KLOTHIQ — Browser Supabase Client Instance
// ─────────────────────────────────────────────

import { createKlothiqClient } from '@klothiq/supabase-client';

const DEFAULT_SUPABASE_URL = 'https://kptekyhxaogjncwacesk.supabase.co';
const DEFAULT_SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtwdGVreWh4YW9nam5jd2FjZXNrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUzMDI1MjYsImV4cCI6MjEwMDg3ODUyNn0.kjqi-yl11fOIqFLoRvUDduStVHMkdpB5mxK4rKD5AWM';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || DEFAULT_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || DEFAULT_SUPABASE_ANON_KEY;

export const supabase = createKlothiqClient(supabaseUrl, supabaseAnonKey);
